import { Task } from 'lendio-borrower/models/task/task.model';


export class CreateTask {
  static readonly type = '[Tasks] CreateTask';
  constructor(public task: Task) {}
}

export class UpdateTaskContractRequest {
  static readonly type = '[Tasks] UpdateTask';
  constructor(public updatedTask: Task) {}
}

export class TaskCreated {
  static readonly type = '[Tasks] TaskCreated';
  constructor(public task: Task) {}
}

export class GetTasksForBorrower {
  static readonly type = '[Tasks] GetTasksForBorrower';
  constructor(public borrowerId: number) {}
}

export class GetIssueTypes {
  static readonly type = '[Tasks] GetIssueTypes';
  constructor() {}
}

export class CompleteTask {
  static readonly type = '[Tasks] CompleteTask';
  constructor(public updatedTask: Task, public borrowerName?: string) {}
}

export class ReOpenTask {
  static readonly type = '[Tasks] ReOpenTask';
  constructor(public updatedTask: Task) {}
}
